export default __webpack_public_path__ + "static/firewall-01349bf9d930d313befce153e33227e2.png";